<ion-content class="ion-padding">
  <div class="loading-wrapper">
    <ion-card class="loading-card" *ngIf="state === 'loading'">
      <ion-spinner name="crescent"></ion-spinner>
      <ion-label>Loading, please wait...</ion-label>
    </ion-card>

    <ion-card class="loading-card error" *ngIf="state === 'failed'">
      <ion-icon name="alert-circle-outline"></ion-icon>
      <ion-label>Something went wrong!</ion-label>
      <ion-button expand="block" color="danger" (click)="goToLogin()">Go to Login</ion-button>
    </ion-card>

    <!-- Success - Auto redirect (native app) -->
    <ion-card class="loading-card success" *ngIf="state === 'success' && !showOpenAppButton">
      <ion-icon name="checkmark-circle-outline"></ion-icon>
      <ion-label>Success! Redirecting...</ion-label>
    </ion-card>

    <!-- Success - Show button (Android browser) -->
    <ion-card class="loading-card success" *ngIf="state === 'success' && showOpenAppButton">
      <ion-icon name="checkmark-circle-outline"></ion-icon>
      <ion-label>Login Successful!</ion-label>
      <p style="text-align: center; margin: 16px 0; color: #666;">
        Tap the button below to open Skill Mantra app
      </p>
      <a [href]="deepLinkUrl" style="text-decoration: none;">
        <ion-button expand="block" color="primary">
          <ion-icon name="phone-portrait-outline" slot="start"></ion-icon>
          Open Skill Mantra App
        </ion-button>
      </a>
    </ion-card>
  </div>
</ion-content>
  